import { render, staticRenderFns } from "./disliked-dropdown.vue?vue&type=template&id=1c6ac007&scoped=true&"
import script from "./disliked-dropdown.vue?vue&type=script&lang=js&"
export * from "./disliked-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ac007",
  null
  
)

export default component.exports